export enum Routes {
    GetUpdates = 'get-updates',
    ConfirmView = 'confirm',
}
